import React, { useRef, forwardRef, useImperativeHandle } from 'react';

const FileUpload = forwardRef(({ uploadCount, alertVisible, handleFilesUpload, allowedExtensions }, ref) => {
    const fileInputRef = useRef(null);

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    useImperativeHandle(ref, () => ({
        triggerFileInput
    }));

    const handleFileSelect = (e) => {
        var files = Array.from(e.target.files)
        handleFilesUpload(files)

        // Reset the file input value to allow re-selecting the same file
        e.target.value = null;
    }

    return (
        <div>
            <input
                type="file"
                multiple
                onChange={handleFileSelect}
                style={{ display: 'none' }}
                ref={fileInputRef}
                accept={allowedExtensions}
            />

            {alertVisible && (
                <div className="alert alert-info d-flex align-items-center" role="alert">
                    <div>
                        <strong>Uploading {uploadCount} files...</strong>
                    </div>
                    <div className="spinner-border text-info ml-auto" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
});

export default FileUpload;
